export default __webpack_public_path__ + "./images/om.2d8de0c0.png";